import api from "../utils/api";
import { IAdminOrder } from "../views/AdminOrdersView/types";
import { IAdminLocation } from "../views/AdminDeliveriesView/types";

const DELIVERY_LOCATION_BASE_PATH = "/deliverylocation";

export interface IDeliveryLocationModel {
  _id: string;
  address: string;
  address2?: string;
  city: string;
  estimatedMinutes: number;
  gatedPropertyDetails?: string;
  gpsInaccurateDescription?: string;
  isContactPersonRequired: boolean;
  isGatedProperty: boolean;
  isGpsAccurate: boolean;
  name: string;
  phoneNumber: string;
  tankConnectionDetails: string;
  tankDistance: string;
  service: string;
  zipCode: string;
  start: string;
  end: string;
}

export interface IDeliveryTime {
  startTime: string;
  driverId: string;
}

export type IAvailableDeliveryTimes = IDeliveryTime[];

interface IUpdateDeliveryLocationOptions {
  notifyCustomer?: boolean;
}

export const DeliveryLocationModel = {
  /**
   * @throws {Error}
   */
  get: async (): Promise<IDeliveryLocationModel | null> => {
    try {
      const response = await api.get<IDeliveryLocationModel>(
        DELIVERY_LOCATION_BASE_PATH
      );
      return response.data;
    } catch (e: any) {
      console.error(e);
      throw e;
    }
  },

  // Get by Order's deliveryLocationId
  /**
   * @throws {Error}
   */
  getByOrder: async (orderId: string): Promise<IDeliveryLocationModel | null> => {
    try {
      const response = await api.get<IDeliveryLocationModel>(
        `${DELIVERY_LOCATION_BASE_PATH}/${orderId}`
      );
      return response.data;
    } catch (e: any) {
      console.error(e);
      throw e;
    }
  },

  /**
   * @throws {Error}
   */
  getAll: async (
    page: number = 0,
    limit: number = 10,
    search: string = "",
    sortBy: string = "",
    sortOrder: "asc" | "desc" = "desc"
  ): Promise<{ data: IAdminLocation[]; total: number }> => {
    try {
      const params: any = { page, limit, search };
      if (sortBy) {
        params.sortBy = sortBy;
        params.sortOrder = sortOrder;
      }
      const response = await api.get<any>(`admin/userLocations`, {
        params,
      });
      return {
        data: response.data.locations,
        total: response.data.total,
      };
    } catch (e: any) {
      console.error(e);
      throw e;
    }
  },

  /**
   * @throws {Error}
   */
  put: async (
    orderId: string,
    deliveryLocation: IDeliveryLocationModel,
    options: IUpdateDeliveryLocationOptions = {}
  ): Promise<IDeliveryLocationModel> => {
    try {
      const response = await api.put<IDeliveryLocationModel>(
        `${DELIVERY_LOCATION_BASE_PATH}/${orderId}`,
        {
          ...deliveryLocation,
          notifyCustomer: options.notifyCustomer,
        }
      );
      return response.data;
    } catch (e: any) {
      console.error(e);
      throw e;
    }
  },

  getOrderByLocationId: async (locationId: string): Promise<IAdminOrder | null> => {
    try {
      const response = await api.get<IAdminOrder>(
        `${DELIVERY_LOCATION_BASE_PATH}/orderByLocationId/${locationId}`
      );
      return response.data;
    } catch (e: any) {
      console.error(e);
      throw e;
    }
  },
};
